import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { ObjectAlert } from "../alerts";
import { ScriptLinkObjectEditor } from "../objectEditors";

export class ScriptLinkObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: ObjectAlert[] = [];
    if (object instanceof ScriptLinkObjectEditor) {
      const behavior = object.scriptExecuteBehavior().getValue();
      if (!behavior.scriptPath) {
        alerts.push(new ObjectAlert(object, "実行ファイルパスを設定してください。"));
      }

      if (!behavior.csvFilePathFormat) {
        alerts.push(new ObjectAlert(object, "CSVファイルパスを入力してください。"));
      }
      
      if (behavior.parameters.length < 1) {
        alerts.push(new ObjectAlert(object, "パラメータを設定をしてください。"));
      }
    }
    return alerts;
  }
}
